import { fetchTxsRequest } from "actions";
import { BBABalance, BlockNumber } from "components/blockchain";
import { TxHash } from "components/common/TxHash";
import Table from "components/datatable/table";
import { TxInterface } from "interfaces/tx.interface";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { AppDispatch } from "store";

const HomeTxs = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { txs } = useSelector((state: RootState) => state.txs);

  useEffect(() => {
    dispatch(fetchTxsRequest(txs.meta.page, txs.meta.take));
  }, [dispatch, txs.meta.page, txs.meta.take]);

  // Define the columns with optional "render" for custom display
  const columns = [
    {
      title: "Tx Hash",
      render: (value: any, tx: TxInterface) => (
        <>
          <TxHash hash={tx.signature} link truncate={16} />
          <p className="text-xsmall text-gray-700">
            {moment.unix(tx.block?.block_time).fromNow()}
          </p>
        </>
      ),
    },
    {
      title: "Block Height",
      render: (value: any, tx: TxInterface) => (
        <div className="flex max-w-[160px] gap-[1px]">
          <BlockNumber height={tx.block_number} link />
        </div>
      ),
    },
    {
      title: "Fee",
      render: (value: any, tx: TxInterface) => <BBABalance daltons={tx.fee} />,
    },
  ];

  return (
    <Table
      data={txs.data}
      columns={columns}
      tableClassName="table w-full noscroll"
    />
  );
};

export default HomeTxs;
